import React from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@mui/material';
import { useTranslationHook } from '../../hooks';
import EmailRecipientSelector from './EmailRecipientSelector';

interface TenderAccountEmails {
  accountId: number;
  accountName: string;
  emails: string[];
}

interface RecipientSelectionDialogProps {
  open: boolean;
  title: string;
  onConfirm: () => void;
  onCancel: () => void;
  tenderAccountEmails: TenderAccountEmails[];
  selectedEmails: string[];
  onSelectionChange: (emails: string[]) => void;
}

const RecipientSelectionDialog: React.FC<RecipientSelectionDialogProps> = (props) => {
  const { t } = useTranslationHook();
  const {
    open,
    title,
    onConfirm,
    onCancel,
    tenderAccountEmails,
    selectedEmails,
    onSelectionChange,
  } = props;

  return (
    <Dialog open={open} fullWidth maxWidth="md">
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Box sx={{ mt: 2 }}>
          <EmailRecipientSelector
            tenderAccountEmails={tenderAccountEmails}
            value={selectedEmails}
            onSelectionChange={onSelectionChange}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel}>{t("notification.dont-send")}</Button>
        <Button onClick={onConfirm} autoFocus>
          {t("notification.send")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RecipientSelectionDialog;
